import React from 'react';

const Team = () => {
  const team = [
    {
      name: 'Alex Johnson',
      role: 'CEO & Co-Founder',
      bio: 'Visionary leader with 15+ years in digital transformation',
      icon: '👨‍💼'
    },
    {
      name: 'Sarah Chen',
      role: 'CTO & Lead Developer',
      bio: 'Full-stack expert specializing in scalable architectures',
      icon: '👩‍💻'
    },
    {
      name: 'Marcus Williams',
      role: 'Lead Designer',
      bio: 'UI/UX maestro crafting beautiful digital experiences',
      icon: '🎨'
    },
    {
      name: 'Emma Rodriguez',
      role: 'Project Manager',
      bio: 'Ensuring seamless delivery and client satisfaction',
      icon: '📋'
    },
    {
      name: 'James Park',
      role: 'DevOps Engineer',
      bio: 'Cloud infrastructure and deployment specialist',
      icon: '☁️'
    },
    {
      name: 'Lisa Anderson',
      role: 'QA Lead',
      bio: 'Quality assurance and testing excellence',
      icon: '🧪'
    }
  ];

  return (
    <section id="team">
      <div className="section-header">
        <h2 className="section-title">Meet Our Team</h2>
        <p className="section-subtitle">Talented professionals dedicated to your success</p>
      </div>
      <div className="team-grid">
        {team.map((member, index) => (
          <div className="team-card fade-in" key={index} style={{animationDelay: `${(index % 3) * 0.15}s`}}>
            <div className="member-avatar">{member.icon}</div>
            <h4>{member.name}</h4>
            <p className="role">{member.role}</p>
            <p className="bio">{member.bio}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Team;
